<template>
  <SogCard class="sog-card-without-title">
    <SogCardContent v-show="_items.length===0">
      Einkaufswagen ist leer.
    </SogCardContent>
    <SogCardContent v-show="_items.length>0">
      <SogFlexRow style="justify-content: flex-start">
        <ShoppingCartItemComponent
          v-for="item in _items"
          :key="item"
          class="sog-card-without-title"
          :item="item"
          :is-invoiced="_isInvoiced"
        >
          <SogCardActions>
            <SogCardActionButton
              mdi-icon="mdi-delete"
              @click="onDelete(item.id)"
            />
          </SogCardActions>
        </ShoppingCartItemComponent>
      </SogFlexRow>
      <SogFlexRow
        v-show="_isInvoiced"
        style="justify-content: end"
      >
        Gesamtsumme:
        <SogDataLabel
          :value-type="SogDataLabelValueType.Money"
          :value="_amount"
        />
      </SogFlexRow>
      <SogFlexRow style="justify-content: end" />
    </SogCardContent>
    <SogCardActions
      v-show="_items.length>0"
      style="justify-content: end"
    >
      <SogFlexRow style="justify-content: flex-end">
        <SogCardActionButton
          v-show="_items.length>0"
          mdi-icon="mdi-cart-check"
          @click="_router.push('cashpoint')"
        >
          Zur Kasse gehen
        </SogCardActionButton>
      </SogFlexRow>
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">
import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import {onMounted, reactive, ref} from "vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogGrid from "@/shared/ui/SogGrid.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import ShoppingCartItemComponent from "@/modules/ShoppingCart/components/ShoppingCartItemComponent.vue";
import {computed} from "vue";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";

const _grid = ref<InstanceType<typeof SogGrid> | null>(null)

const _items = reactive([{
  id: "",
  productType: "",
  product: "",
  count: 0,
  grossPrice: 0,
  amount: 0,
  manufacturer: "" as string,
  item: undefined as ShoppingCartItem | undefined
}])
const _router = useRouter()
const _amount = ref(0)


const _shoppingCartStore = useShoppingCartStore();


async function onDelete(id: string) {
  _shoppingCartStore.removeItem(id)
  refresh();
}

/*
async function commandClick(args: any) {
  if (args?.rowData?.id) {
    _shoppingCartStore.removeItem(args.rowData.id)
    refresh();
  }
  args.cancel = true;
}
*/

async function init(route: RouteLocationNormalizedLoaded) {
  const shoppingCart = useShoppingCartStore();
  const sector = route.params.sector as string;
  if (sector === "purchase") {
    await shoppingCart.initPurchase();
  }
  refresh()
}

function refresh() {
  _items.length = 0;
  const t_array = _shoppingCartStore.getItems();
  t_array.forEach(t => _items.push({
      id: t.id,
      productType: t.insuranceTypeName,
      product: t.productDescription,
      manufacturer: t.manufacturerName,
      count: t.count,
      grossPrice: t.grossPrice,
      amount: t.amount,
      item: t
    })
  )

  _amount.value = _shoppingCartStore.amount();

  _grid.value?.refresh();
}

onMounted(async () => {
  const route = useRoute();
  await init(route);
})


onBeforeRouteUpdate(async (to) => {
  await init(to);
})

const _isInvoiced = computed(() => {
  return _shoppingCartStore.currentShoppingCart.isInvoiced
})


</script>

<style>

</style>
